<template>
  <roomInfoScreen v-if="billing.isLoading" :preloader="true"
  >Please wait
  </roomInfoScreen>
  <div v-else class="container">
    <div class="row">
      <div class="col_xl_8 xl_offset_2 col_l_12 col_m_12 col_s_12">
        <p class="tac terms_title">Pricing</p>

        <h3 class="tac pricing_h3">
          Our plans are accessible and friendly with many interesting
          features! Sign up today to feel the difference. Cancel at any
          time.
        </h3>

        <monthlySwitcher @switchMonthly="listenSwitcher"></monthlySwitcher>

        <p class="question tac">
          Questions?

          <a href="mailto:test@test.test" class="hover_op"
          >Talk to an expert!</a
          >
        </p>
      </div>

      <div class="col_xl_4 col_l_4 col_m_12 col_s_12">
        <div class="plan">
          <p class="small">Standard</p>

          <p class="plan_name">Free</p>

          <p class="middle">Inc. applicable taxes</p>

          <template v-if="$store.state.userAuthenticated">
            <button
                v-if="isCurrentPlan('free')"
                class="colored_btn hover_op disabeled"
            >
              Current plan
            </button>
            <button
                @click="changePlan('free')"
                v-else
                class="color_btn hover_op"
            >
              Change plan
            </button>
          </template>

          <router-link v-else to="/sign_up" class="colored_btn hover_op"
          >Sign up, it’s free!
          </router-link
          >

          <ul>
            <li>Chat and mentions</li>
            <li>Clarify settings before a meeting</li>
            <li>Custom invites</li>
            <li>HD quality audio</li>
            <li>HD quality video</li>
            <li>International access</li>
            <li>Lock rooms</li>
            <li>Meeting rooms capacity (up to 100)</li>
            <li>One-to-one meetings</li>
            <li>Group meetings</li>
            <li>Reactions</li>
            <li>Screen sharing</li>
          </ul>
        </div>
      </div>

      <div class="col_xl_4 col_l_4 col_m_12 col_s_12">
        <div class="plan active">
          <p class="small">{{ billing_plans[0].name }}</p>

          <p class="plan_name">
            $
            {{
              monthly
                  ? billing_plans[0].monthly.amount + " / month"
                  : billing_plans[0].yearly.amount + " / year"
            }}
          </p>

          <p class="middle">Inc. applicable taxes</p>

          <template v-if="$store.state.userAuthenticated">
            <button
                v-if="isCurrentPlan(billing_plans[0])"
                class="colored_btn hover_op disabeled"
            >
              Current plan
            </button>
            <button
                @click="changePlan(billing_plans[0])"
                v-else
                class="color_btn hover_op"
            >
              Change plan
            </button>
          </template>


          <ul>
            <li>Chat and mentions</li>
            <li>Clarify settings before a meeting</li>
            <li>Custom invites</li>
            <li>HD quality audio</li>
            <li>HD quality video</li>
            <li>International access</li>
            <li>Lock rooms</li>
            <li>Meeting rooms capacity (up to 100)</li>
            <li>One-to-one meetings</li>
            <li>Group meetings</li>
            <li>Reactions</li>
            <li>Screen sharing</li>
            <li>Unlimited conference duration</li>
            <li>Captions</li>
            <li>Custom meeting rooms</li>
            <li>Meeting recording</li>
          </ul>
        </div>
      </div>

      <div class="col_xl_4 col_l_4 col_m_12 col_s_12">
        <div class="plan" v-if="billing_plans">
          <p class="small">{{ billing_plans[1].name }}</p>

          <p class="plan_name">
            $
            {{
              monthly
                  ? billing_plans[1].monthly.amount + " / month"
                  : billing_plans[1].yearly.amount + " / year"
            }}
          </p>

          <p class="middle">Inc. applicable taxes</p>

          <template v-if="$store.state.userAuthenticated">
            <button
                v-if="isCurrentPlan(billing_plans[1])"
                class="colored_btn hover_op disabeled"
            >
              Current plan
            </button>
            <button
                @click="changePlan(billing_plans[1])"
                v-else
                class="color_btn hover_op"
            >
              Change plan
            </button>
          </template>

          <router-link v-else to="/sign_up" class="color_btn hover_op"
          >Try free for 14-days
          </router-link
          >

          <ul>
            <li>Chat and mentions</li>
            <li>Clarify settings before a meeting</li>
            <li>Custom invites</li>
            <li>HD quality audio</li>
            <li>HD quality video</li>
            <li>International access</li>
            <li>Lock rooms</li>
            <li>Meeting rooms capacity (up to 100)</li>
            <li>One-to-one meetings</li>
            <li>Group meetings</li>
            <li>Reactions</li>
            <li>Screen sharing</li>
            <li>Unlimited conference duration</li>
            <li>Captions</li>
            <li>Custom meeting rooms</li>
            <li>Meeting recording</li>
            <li>Priority support</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import monthlySwitcher from "@/components/monthlySwitcher.vue";

export default {
  name: "PricingGrid",
  components: {
    monthlySwitcher,
  },
  data() {
    return {
      monthly: false
    }
  },
  computed: {
    billing() {
      return {
        isLoading: this.$store.state.billing.isLoading,
        subscription: this.$store.state.billing.subscription,
        products: this.$store.state.billing.products,
      };
    },

    billing_plans() {
      return this.$store.state.billing.products
    }
  },

  methods: {
    isCurrentPlan(plan) {
      if (plan === "free") {
        console.log(this.billing.subscription.status === "deleted")
        return (
            this.billing.subscription.status === "deleted" || this.billing.subscription.planId === "free"
        );
      } else {
        const planId = this.monthly ? plan.monthly.id : plan.yearly.id

        return this.billing.subscription?.status !== "deleted" && this.billing.subscription?.planId === planId;
      }
    },
    async changePlan(plan) {
      let planId
      if (plan === "free") {
        planId = "free"

        if (!confirm("You are about to cancel your current subscription. Are you sure?")) {
          return
        }

        await this.$store.dispatch("cancelSubscription")
        this.$router.push("/user_subscriptions")

      } else {
        planId = this.monthly ? plan.monthly.id : plan.yearly.id
        await this.$store.dispatch("checkout", planId)
      }
    },
    listenSwitcher(switcherMonthly) {
      this.monthly = switcherMonthly;
    },
  },
}
</script>

<style scoped>

</style>